import { IPositionType } from './position-type'

// The side of the grid as the project drawing shows it: columns run left to right, rows bottom to top.
export enum IGridSide {
  Left = 0,
  Right = 1,
  Bottom = 2,
  Top = 3,
}

export enum IGridExpansionStatus {
  Ready = 0,
  NotADraft = 1,
  NotSupported = 2,
  NotPlaced = 3,
  NoCoordinates = 4,
  NamesExhausted = 5,
}

export interface IGridCage {
  name?: string
  reference?: string
  column: number
  row: number
}

// A mooring line on the side being expanded: the corner it leaves and the new corner at the grown edge, by name and grid place.
export interface IGridEdgeLine {
  id: number
  name?: string
  fromCorner: string
  toCorner: string
  fromColumn: number
  fromRow: number
  toColumn: number
  toRow: number
}

export interface IGridExpansionPreview {
  status: IGridExpansionStatus
  cages: IGridCage[]
  added: { type: IPositionType; count: number }[]
  edgeLines: IGridEdgeLine[]
}

export interface IExpandGrid {
  side: IGridSide
  count: number
  replacedLineIds: number[]
}
